// extracted by mini-css-extract-plugin
export default {"constructor":"burger-constructor_constructor__hO4kE"};